import { TStatus } from '@/types/task.interface'
import {
	TExternalSource,
	TLangCode,
	TPlatformValue
} from '@/types/uploadForm.interface'

export const STATUS: Record<string, TStatus> = {
	FINISHED: 'finished',
	IN_PROGRESS: 'in_progress',
	ADDED: 'added',
	FAILED: 'failed'
}

export const LANGUAGES = {
	MAIN: [
		{
			code: 'en',
			language: 'English'
		},
		{
			code: 'ru',
			language: 'Russian'
		}
	],
	INT: [
		{
			code: 'en',
			language: 'English'
		},
		{
			code: 'es',
			language: 'Spanish'
		},
		{
			code: 'ar',
			language: 'Arabic'
		}
	]
}

export enum STEP_TYPE {
	TRANSCRIBE = 'transcribe',
	UPLOAD = 'upload'
}

export const PLATFORM_API_MAP: Record<
	TPlatformValue,
	{
		source: TExternalSource
		lang: TLangCode
	}
> = {
	english: { source: 'viory', lang: 'en' },
	arabic: { source: 'viory', lang: 'ar' },
	spanish: { source: 'viory', lang: 'es' },
	'main-english': { source: 'ruptly', lang: 'en' },
	'main-russian': { source: 'ruptly', lang: 'ru' }
}
